import * as React from 'react'
import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'
import ApolloWrapper from './ApolloWrapper'

const query = gql`
    query userInfoForUpdateUser {
        user {
            attributes {
                authenticationId
                firstName
                lastName
                mobilePhone
                email
                isGlobalAdmin
                authenticationUsername
                databaseId
            }
            permissions {
                userPermissions {
                    key
                    description
                    note
                }
            }
            organizations {
                orgId
                displayName
                description
                isAdmin
                lastUpdated
                type
            }
            roles {
                id
                name
                description
            }
        }
    }
`

const Welcome: React.FC = () => {
    const { data, loading, error, ...rest } = useQuery(query)

    console.log({ data, loading, error, ...rest })

    const networkErrorStatus = (error?.networkError as any)?.response?.status
    const networkErrorMessage = (error?.networkError as any)?.message

    if (loading && !data) {
        return <h1>Loading data...</h1>
    }

    if (networkErrorStatus) {
        return <h1>Status (errorStatus): {networkErrorMessage}</h1>
    }

    if (error) {
        return <h1>Error: {error.message}</h1>
    }

    console.log(data)
    const email = data.user.attributes.email

    if (!email) {
        return <h1>No email</h1>
    }
    return <h1>Welcome from Apollo: {email}!</h1>
}

export const SparkDataAccessApolo: React.VFC = () => (
    <ApolloWrapper>
        <Welcome />
    </ApolloWrapper>
)
export default SparkDataAccessApolo
